<template>
  <div />
</template>

<script>

/**
 * Vue: Next day shipping data (next-day-shipping-data)
 * -----------------------------------------------------------------------------
 * Async component to handle passing section settings to Vuex store when on
 * relevant templates.
 *
 * @param {Array} markets - Next day shipping markets.
 * @param {Object} settings - Section settings.
 *
 */
import { mapActions } from 'vuex'

export default {
  name: 'NextDayShippingData',

  props: {
    markets: {
      type: Array,
      default: () => [],
      required: true,
    },
    settings: {
      type: Object,
      default: () => ({
        countdown: 4,
        enable: true,
        fallbackUrl: '',
      }),
      required: true,
    },
  },

  mounted() {
    this.setMarkets(this.markets)
    this.setSettings(this.settings)
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      setMarkets: 'next-day-shipping/setMarkets',
      setSettings: 'next-day-shipping/setSettings',
    }),
  },
}
</script>
